/**
 * Anzeige-Helfer für den Sendungsstatus (17TRACK → orders.shipments / orders.shipmentSummary /
 * shipments/{trackingCode}). Texte und Farben an EINER Stelle, damit OrderView, Support-Ansicht
 * und die Sendungsliste dasselbe sagen. Status-/Flag-Werte: functions/tracking/track17.js.
 */
export const SHIPMENT_STATUS = {
  registered: { label: "Noch kein Scan", color: "#9e9e9e", icon: "mdi-package-variant-closed" },
  pending: { label: "Noch kein Scan", color: "#9e9e9e", icon: "mdi-package-variant-closed" },
  in_transit: { label: "Unterwegs", color: "#1e88e5", icon: "mdi-truck-fast-outline" },
  out_for_delivery: { label: "In Zustellung", color: "#1e88e5", icon: "mdi-truck-delivery-outline" },
  pickup: { label: "Im Paketshop", color: "#f9a825", icon: "mdi-store-outline" },
  delivered: { label: "Zugestellt", color: "#2e7d32", icon: "mdi-check-circle" },
  failed: { label: "Zustellung fehlgeschlagen", color: "#d8493f", icon: "mdi-alert-circle" },
  exception: { label: "Problem beim Carrier", color: "#d8493f", icon: "mdi-alert-circle" },
  returned: { label: "Rücksendung", color: "#d8493f", icon: "mdi-undo-variant" },
  expired: { label: "Verfolgung abgelaufen", color: "#9e9e9e", icon: "mdi-clock-alert-outline" },
  unknown: { label: "Unbekannt", color: "#9e9e9e", icon: "mdi-help-circle-outline" },
};

export const SHIPMENT_FLAG = {
  stalled: { label: "Keine Bewegung", color: "#ef6c00" },
  pickup: { label: "Liegt im Paketshop", color: "#f9a825" },
  failed: { label: "Zustellung fehlgeschlagen", color: "#d8493f" },
  exception: { label: "Problem beim Carrier", color: "#d8493f" },
  returned: { label: "Rücksendung", color: "#d8493f" },
  not_found: { label: "Noch kein Scan", color: "#9e9e9e" },
};

export const shipmentStatusMeta = (status) => SHIPMENT_STATUS[status] || SHIPMENT_STATUS.unknown;
export const shipmentFlagMeta = (flag) => (flag ? SHIPMENT_FLAG[flag] || { label: flag, color: "#ef6c00" } : null);

/** Sendungsdaten zu einem Fulfill-Item (über die Tracking-Nummer) */
export const shipmentForItem = (order, item) => {
  const code = item && item.shipment && item.shipment.trackingCode;
  return (code && order && order.shipments && order.shipments[code]) || null;
};

/** Kurzer Einzeiler „Unterwegs · vor 2 Std. · Köln" */
export const shipmentLine = (shipment, ago) => {
  if (!shipment) return "";
  const parts = [shipmentStatusMeta(shipment.status).label];
  if (shipment.lastEventAt && ago) parts.push(ago(shipment.lastEventAt));
  if (shipment.lastEventLocation) parts.push(shipment.lastEventLocation);
  return parts.join(" · ");
};

const DAY_MS = 86400000;
const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;

/**
 * Werktage (Mo–Fr) zwischen zwei Zeitpunkten, Zehntel. Gleiche Rechnung wie im Backend
 * (functions/tracking/track17.js bizDays): Kalenderdauer minus Zeit an Samstagen/Sonntagen.
 */
export const bizDaysBetween = (from, to) => {
  const a = from ? new Date(from).getTime() : NaN;
  const b = to ? new Date(to).getTime() : NaN;
  if (!(a && b) || Number.isNaN(a) || Number.isNaN(b) || b <= a) return null;
  let weekendMs = 0;
  let day = new Date(a);
  day.setHours(0, 0, 0, 0);
  while (day.getTime() < b) {
    const start = day.getTime();
    const end = start + DAY_MS;
    if (isWeekend(day)) weekendMs += Math.min(end, b) - Math.max(start, a);
    day = new Date(end);
  }
  return Math.round((Math.max(0, b - a - weekendMs) / DAY_MS) * 10) / 10;
};
